
































import { Venda } from '@/models'
import { obterTotalDaVenda, obterTotalDaVendaSemDesconto, obterTotalDeTaxas } from '@/shareds/venda-shareds'
import { CashbackCrmBonusUseCase } from '@/usecases/cliente/CashbackCrmBonusUseCase'
import { Vue, Component, Ref } from 'vue-property-decorator'
import { CrmBonusModule } from '@/store/vuex/venda/CrmBonusStore'

@Component({
	components: {
		
	},
})
export default class SeletorDeCampanhasCrmBonus extends Vue {
	@Ref() form!: HTMLFormElement

	cashbackCrmBonusUseCase = new CashbackCrmBonusUseCase()

	mostra = false
	valorCashbackAplicado = 0
	lojaId: string | null = null
	venda: Venda | null = null
	buscandoCampanhas = false

	campanhasDisponiveis: any[] = []
	campanhaSelecionada: any = null

	async mostrar(lojaId: string, valorCashbackAplicado: number, venda: Venda) {
		this.lojaId = lojaId
		this.valorCashbackAplicado = valorCashbackAplicado
		this.venda = venda

		await this.buscarCampanhas()

		if (this.campanhasDisponiveis.length === 1) {
			this.campanhaSelecionada = this.campanhasDisponiveis[0]
			CrmBonusModule.setDados({
				campanha: this.campanhaSelecionada.idCampanha,
			})
			this.esconder()
			return
		}

		this.mostra = true

		setTimeout(() => {
			this.form.resetValidation()
		})
	}

	esconder() {
		this.mostra = false
		this.campanhaSelecionada = null
		this.campanhasDisponiveis = []
	}

	async buscarCampanhas() {
		if (!CrmBonusModule.dados.userIdNoCrm || !CrmBonusModule.dados.requestHash || !this.lojaId || !this.venda) return

		this.buscandoCampanhas = true

		try {

			const valorBruto = obterTotalDaVendaSemDesconto(this.venda)
			const valorLiquido = obterTotalDaVenda(this.venda)
			const taxasDaVenda = obterTotalDeTaxas(this.venda)
			const itensValidos = this.venda.itens.filter(item => {
				return !item.isBrinde && item.quantidade > 0
			})

			const params = {
				userId: CrmBonusModule.dados.userIdNoCrm,
				requestHash: CrmBonusModule.dados.requestHash,
				lojaId: this.lojaId,
				taxas: taxasDaVenda,
				valorBruto: valorBruto,
				valorLiquido: valorLiquido,
				desconto: this.valorCashbackAplicado,
				itens: itensValidos,
			}

			const campanhas = await this.cashbackCrmBonusUseCase.consultarCampanhasDisponiveisCrmBonus(params)

			this.campanhasDisponiveis = campanhas

		} catch (error) {
			console.error('Erro ao buscar campanhas:', error)
			this.esconder()
		} finally {
			this.buscandoCampanhas = false
		}
	}

	confirmarCampanha() {
		if (!this.form.validate()) return
		CrmBonusModule.setDados({
			campanha: this.campanhaSelecionada.idCampanha,
		})

		this.esconder()
	}

}
